<template>
    <div>
        <v-flex
                row wrap align-top justify-center>
            <SearchList :elements="startups"
                  :titleHeader="header"
                  :addNewTitle="addNewStartupTitle"
                  :showSearchButton="showSearchButton"
                  :searchCallback="searchStartups"
                  :clickCallback="navigate"
                  :searchStartup="searchStartups"
                  :deleteCallback="openDeleteStartupDialog"></SearchList>
        </v-flex>

        <v-dialog
                v-model="deleteStartupDialog"
                max-width="650"
        >
            <v-card>
                <v-card-title class="headline">Deleting {{ selectedStartup.nameToShow}} </v-card-title>
                <v-card-text>
                    Are you sure?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="closeDeleteStartupDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="red"
                            flat="flat"
                            @click="deleteStartup()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>


</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import SearchList from "@/components/Lists/SearchList";
    import ExcelJS from 'exceljs';
    import FileSaver from 'file-saver';

    export default {
        name: "StartupList",
        components: {SearchList},
        props: {
            approved: Number,
        },
        data() {
            return {
                showSearchButton: true,
                header: "Startups",
                addNewStartupTitle: "Search Startup",
                startups: [],
                completeStartups: [],
                selectedStartup: {},
                deleteStartupDialog: false,
            }
        },
        methods: {
            navigate(startup) {
                console.log(startup)
                let path = {
                    name: "StartupInfo",
                    params: {
                        //approved: this.approved,
                        startupId: startup.id
                        //startupName: startup.nameToShow,
                    },
                };
                RouterService.goTo(path);
            },
            searchStartups(search_query) {
                let requestUrl = {
                    url: UrlsService.searchStartup,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text:search_query,
                        elasticSearchRequest:{
                            //analyzer:"synonym_analyzer",
                            fuzziness:"1",
                            query: "TEXTUAL",
                            pageSize: 10,
                            pageNumber: 0
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Searched Startups",
                    loading: "Waiting for list of startups...",
                    error: "Cannot get startups...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                console.log(requestObject)
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.startups = [];
                        this.completeStartups = [];
                        let responseSearch = responseSuccess.response.searchResults;
                        this.completeStartups = responseSearch;
                        console.log(responseSearch)
                        for (let i = 0; i < responseSearch.length; i++) {
                            this.startups.push({
                                id: responseSearch[i]["id"],
                                nameToShow: responseSearch[i].name,
                                email: responseSearch[i]["ContactDetails"],
                            });
                            if (i !== responseSearch.length - 1) {
                                this.startups.push({divider: true, inset: false,});
                            }
                        }
                    });
    }
        }
    }
</script>

<style scoped>

</style>